import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M23,22c-.415,0-.92-.207-1.455-.426-.658-.269-1.404-.574-2.212-.574s-1.554,.305-2.212,.574c-.535,.219-1.041,.426-1.455,.426s-.92-.207-1.455-.426c-.658-.269-1.404-.574-2.212-.574s-1.554,.305-2.212,.574c-.388,.159-.76,.311-1.093,.383l3.752-8.471,7.186,3.276c.391,.179,.807,.268,1.223,.268,.464,0,.927-.111,1.355-.331,.815-.419,1.384-1.179,1.56-2.083,1.108-5.695-1.6-11.261-6.587-13.535C12.049-1.26,5.913,.356,2.592,4.926c-.549,.756-.728,1.71-.489,2.618,.233,.886,.837,1.608,1.658,1.982l6.865,3.13-3.919,8.849c-.615-.249-1.302-.505-2.041-.505-.808,0-1.554,.305-2.212,.574-.535,.219-1.04,.426-1.455,.426-.552,0-1,.448-1,1s.448,1,1,1c.808,0,1.554-.305,2.212-.574,.535-.219,1.04-.426,1.455-.426s.92,.207,1.455,.426c.658,.269,1.404,.574,2.212,.574s1.554-.305,2.212-.574c.535-.219,1.04-.426,1.455-.426s.92,.207,1.455,.426c.658,.269,1.404,.574,2.212,.574s1.554-.305,2.212-.574c.535-.219,1.041-.426,1.455-.426s.92,.207,1.455,.426c.658,.269,1.404,.574,2.212,.574,.552,0,1-.448,1-1s-.448-1-1-1Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/umbrella-icon.jsx